import { ReactComponent } from "./ic_delay_active.svg";

interface Props {
  fill?: string;
  className?: string;
  width?: string;
  height?: string;
}

const WarningIcon: React.FC<Props> = (Props) => <ReactComponent {...Props} />;

export default WarningIcon;
